<template>
  <div class="invite-intro">
    <div class="activity-info">
      <wb-logo :cssStyle="{ padding: '44px 20px 24px' }" />

      <div class="intro-wrap">
        <intro-title :titles="[$t('loginActivity.newUserTxt1'), $t('loginActivity.newUserTxt2')]" />
        <img class="intro-flag" src="@/assets/images/invite_flag.webp" />
        <div class="intro-list">
          <intro-item
            v-for="(introItem, introIndex) in introList"
            :key="introIndex"
            :icon="introItem.icon"
            :label="introItem.label"
          />
        </div>
      </div>

      <div class="advantage-wrap">
        <advantage-title :title="$t('loginActivity.winbullIntroTitle')" />
        <advantage-item
          v-for="(advantageItem, advantageIndex) in advantageList"
          :key="advantageIndex"
          :icon="advantageItem.icon"
          :label="advantageItem.label"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import WbLogo from '@/components/wb-logo.vue'
  import IntroTitle from './intro-title.vue'
  import IntroItem from './intro-item.vue'
  import AdvantageTitle from './advantage-title.vue'
  import AdvantageItem from './advantage-item.vue'
  import i18n from '@/language'
  export default {
    name: 'invite-intro',

    components: {
      WbLogo,
      IntroTitle,
      IntroItem,
      AdvantageTitle,
      AdvantageItem
    },

    data() {
      return {
        introList: [
          // {
          //   icon: require('@/assets/images/invite_icon_bx1.webp'),
          //   label: i18n.t('loginActivity.newUserIntro1')
          // },
          {
            icon: require('@/assets/images/invite_icon_bx2.webp'),
            label: i18n.t('loginActivity.newUserIntro2')
          },
          {
            icon: require('@/assets/images/invite_icon_bx3.webp'),
            label: i18n.t('loginActivity.newUserIntro3')
          }
          // {
          //   icon: require('@/assets/images/invite_icon_bx4.webp'),
          //   label: i18n.t('loginActivity.newUserIntro4')
          // }
        ],

        advantageList: [
          {
            icon: require('@/assets/images/icon_winbull_intro1.webp'),
            label: i18n.t('loginActivity.winbullIntro1')
          },
          {
            icon: require('@/assets/images/icon_winbull_intro2.webp'),
            label: i18n.t('loginActivity.winbullIntro2')
          },
          // {
          //   icon: require('@/assets/images/icon_winbull_intro3.webp'),
          //   label: i18n.t('loginActivity.winbullIntro3')
          // },
          // {
          //   icon: require('@/assets/images/icon_winbull_intro4.webp'),
          //   label: i18n.t('loginActivity.winbullIntro4')
          // },
          {
            icon: require('@/assets/images/icon_winbull_intro5.webp'),
            label: i18n.t('loginActivity.winbullIntro5')
          },
          {
            icon: require('@/assets/images/icon_winbull_intro6.webp'),
            label: i18n.t('loginActivity.winbullIntro6')
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invite-intro {
    width: 100%;
    height: 100%;
    // overflow-y: auto;

    .activity-info {
      width: 100%;
      height: 417px;
      background-image: url('../../../assets/images/invite_bg.webp');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center bottom;
    }

    .intro-wrap {
      position: relative;
      margin: 0 16px;
      border-radius: 8px;
      background: linear-gradient(216deg, #bedcff 2%, #deedff 76%);
      padding: 16px 8px 15px;

      .intro-list {
        position: relative;
        padding: 8px 12px;
        border-radius: 6px;
        background: #ffffff;
        z-index: 0;
      }

      .intro-flag {
        position: absolute;
        top: 18.5px;
        right: 13px;
        width: 122px;
        height: 67.5px;
        z-index: 0;
      }
    }

    .advantage-wrap {
      margin: 0 16px;
      padding-bottom: 38px;
    }
  }
</style>
